import { TextControl } from './TextControl';

export default TextControl;
